import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var TelegramIcon = function(param) {
    var to = param.to;
    return /*#__PURE__*/ _jsx(Link, {
        href: to,
        target: "_blank",
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M11.2403 17.6069C15.4425 16.9249 18.2963 12.9654 17.6143 8.76317C16.9323 4.56089 12.9728 1.70715 8.77052 2.38915C4.56824 3.07115 1.71449 7.03064 2.3965 11.2329C3.0785 15.4352 7.03799 18.2889 11.2403 17.6069Z",
                    stroke: "#777E90",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M5.70859 10.4667C5.60859 10.425 5.42525 10.3417 5.41692 10.2167C5.40859 10.0917 5.52526 9.95004 5.80026 9.85004L13.2252 6.9917C13.5669 6.8667 13.8753 7.08337 13.7503 7.58337L12.5086 13.55C12.4169 13.9834 12.1669 14.075 11.7919 13.8917C11.1252 13.4417 10.4503 12.9917 9.78359 12.5417C9.42526 12.8084 9.07526 13.0834 8.71692 13.35C8.45859 12.6667 8.19192 11.9834 7.93359 11.3C7.70026 11.2167 6.39192 10.7584 5.70859 10.4667Z",
                    stroke: "#777E90",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
export default TelegramIcon;
var Link = styled.a.withConfig({
    componentId: "sc-5f4e9d4-0"
})(_templateObject());
